"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_parent_1 = require("./fix$parent");
var funcParams_1 = require("./funcParams");
var cacheFuncs = {};
function calcFunction(schema, cache, debug) {
    if (cache === void 0) { cache = true; }
    var func = null;
    var calc = schema.calc;
    if (calc) {
        var funcText = schema.calc;
        var cacheKey = funcText;
        var when = '';
        if (calc.when) {
            funcText = calc.func;
            when = calc.when;
        }
        if (cache && !debug) {
            func = cacheFuncs['calc_' + when + '_' + funcText];
            if (func !== undefined) {
                return func;
            }
        }
        var stext = fix_parent_1.default(funcText);
        var ftext = '';
        switch (schema.type) {
            case 'integer':
                ftext += "return $methods.mround((" + stext + "),0);";
                break;
            // case 'money': ftext += 'return Math.round($result);'; break;
            case 'money':
                ftext += "return $methods.mround((" + stext + "),2);";
                break;
            case 'number':
                if (schema.precision !== undefined) {
                    ftext += "return $methods.mround((" + stext + ")," + schema.precision + ");";
                }
                else {
                    ftext += "return (" + stext + ");";
                }
                break;
            default:
                ftext += "return (" + stext + ");";
                break;
        }
        if (when) {
            ftext = "if (" + fix_parent_1.default(when) + ") {\r\n  " + ftext + "\r\n}";
        }
        if (debug) {
            ftext = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
        }
        if (process.env.NODE_ENV !== 'production') {
            ftext = '"use strict"\r\n' + ftext;
        }
        func = new Function(funcParams_1.default, ftext);
        if (cache && !debug) {
            cacheFuncs['calc_' + when + '_' + funcText] = func;
        }
    }
    return func;
}
exports.default = calcFunction;
//# sourceMappingURL=calcFunction.js.map